export default "__VITE_PUBLIC_ASSET__db1a54bb__"